import config from './data.json'
import {
    getPermissions,
    PERMISSIONS_ROUTES_ONLY,
    PERMISSIONS_SECTIONS_ONLY
} from './acl'

const metadata = config.metadata
export {
    PERMISSIONS_ROUTES_ONLY,
    PERMISSIONS_SECTIONS_ONLY,
    metadata,
    getPermissions
}
